const validatePassword = (password) => {
  if (typeof password !== 'string') {
    return false
  }
  const passwordRegexp =
    /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[a-zA-Z0-9 !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{12,64}$/

  return passwordRegexp.test(password)
}

export default validatePassword
